module.exports = __webpack_public_path__ + "static/media/galerija_2015 (5).8b5a1772.jpg";